import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import styles from './QuantityButtons.module.scss';
import messages from './messages';
import { PDPInStore } from '../../../slices/pdp/types';

type QuantityButtonsProps = {
  preAddedLabel?: number;
  onChange?: () => void;
}

const QuantityButtons = ({
  preAddedLabel,
  onChange,
}: QuantityButtonsProps) => {
  const { formatMessage } = useIntl();
  const {
    selectedSecondSKU,
  } = useSelector((state: { pdp: PDPInStore }) => state.pdp);

  return (
    <div className={styles.QuantityButtonsContainer}>
      <div className={styles.QuantityButtonsLabel}>
        <span>{formatMessage(messages.quantityLabel)}</span>
        {selectedSecondSKU
          ? <span>{formatMessage(messages.secondItemLabel)}</span>
          : <span>{formatMessage(messages.individualLabel)}</span>
        }
      </div>
      <div className={styles.QuantityButtonsControls}>
        <button type="button" aria-label={
          `${formatMessage(messages.individualLabel)} ${formatMessage(messages.quantityLabel)}`
        }
          className={classNames({
            [styles.selected]: !selectedSecondSKU,
          })}
          onClick={selectedSecondSKU ? onChange : undefined}
        >
          {formatMessage(messages.individualLabel)}
        </button>
        <button type="button" aria-label={
          `${formatMessage(messages.secondItemLabel)} 
            ${formatMessage(messages.hyphenLabel)} 
            ${formatMessage(messages.percentageOffLabel)}`
        }
          className={classNames({
            [styles.selected]: !!selectedSecondSKU,
          })}
          onClick={!selectedSecondSKU ? onChange : undefined}
        >
          <span>{formatMessage(messages.secondItemLabel)}</span>
          <span>{formatMessage(messages.hyphenLabel)}</span>
          <span className={styles.promoText}>
            {formatMessage(messages.percentageOffLabel, { percentage: preAddedLabel })}
          </span>
        </button>
      </div>
    </div>
  );
};
export default QuantityButtons;
